import * as React from 'react'
import { Typography } from '@lacedltd/laced-components'
import { useLocale, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import * as S from './PasswordUpdated.styles'

const PasswordUpdated: React.FC<PasswordUpdatedProps> = ({
  securityUpdate = false
}) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()

  return (
    <S.Container>
      <Typography.Heading as="h1">
        {t('react_components.passwords.changed')}
      </Typography.Heading>
      <S.Paragraph as="p" variant="body">
        {t(
          `react_components.passwords.${
            securityUpdate ? 'thanks_updated' : 'updated'
          }`
        )}
      </S.Paragraph>
      <S.ButtonLink href={localiseUrl('/')} className="btn btn--primary">
        {t('react_components.passwords.go_home')}
      </S.ButtonLink>
    </S.Container>
  )
}

interface PasswordUpdatedProps {
  securityUpdate?: boolean
}

export default withTranslations(PasswordUpdated)
